import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'

type ConfirmationDialogProps = {
  title: string
  content: JSX.Element
  onConfirm: () => void
}

const ConfirmationDialog = ({ title, content, onConfirm }: ConfirmationDialogProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Button color="error" onClick={() => setDialogOpen(true)}>
        {content}
      </Button>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Confirm your action</DialogTitle>
        <DialogContent>
          <DialogContentText>{title}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button onClick={onConfirm} color="error">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ConfirmationDialog
